// src/components/admin/AdminBlog.js
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabase';
import { useApp } from '../../lib/AppContext';

export default function AdminBlog() {
  const navigate = useNavigate();
  const { showToast } = useApp();
  const [posts, setPosts] = useState([]);

  useEffect(() => {
    supabase.from('blog_posts').select('id,slug,title,published,category,created_at').order('created_at', { ascending: false })
      .then(({ data }) => setPosts(data || []));
  }, []);

  const togglePublish = async (id, current) => {
    await supabase.from('blog_posts').update({ published: !current }).eq('id', id);
    setPosts(p => p.map(x => x.id === id ? { ...x, published: !current } : x));
    showToast(current ? 'Post unpublished' : 'Post published!', 'success');
  };

  return (
    <div className="page-container" style={{ padding:'32px 24px' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', marginBottom:20 }}>
        <h2 style={{ fontFamily:"'Bebas Neue',sans-serif", fontSize:'1.8rem', letterSpacing:'.05em' }}>Blog Posts</h2>
        <button className="btn-primary" style={{ padding:'9px 20px', fontSize:'.82rem' }} onClick={() => navigate('/admin/blog/new')}>+ New Post</button>
      </div>
      <div style={{ background:'#111', borderRadius:16, border:'1px solid rgba(255,255,255,.07)', overflow:'hidden' }}>
        {posts.length === 0 && <div style={{ textAlign:'center', padding:'3rem', color:'#555' }}>No posts yet</div>}
        {posts.map(post => (
          <div key={post.id} style={{ display:'flex', alignItems:'center', gap:14, padding:'14px 20px', borderBottom:'1px solid rgba(255,255,255,.04)' }}>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ fontFamily:"'Barlow Condensed',sans-serif", fontSize:'.9rem', fontWeight:700, color: post.published?'#f4f4f4':'#555', overflow:'hidden', textOverflow:'ellipsis', whiteSpace:'nowrap' }}>
                {post.title?.en || 'Untitled'}
              </div>
              <div style={{ fontSize:'.75rem', color:'#444', marginTop:2 }}>{post.category} · {new Date(post.created_at).toLocaleDateString()}</div>
            </div>
            <button onClick={() => togglePublish(post.id, post.published)} style={{ background: post.published?'rgba(76,202,116,.12)':'rgba(255,255,255,.05)', border:'none', borderRadius:20, padding:'5px 14px', fontSize:'.72rem', fontWeight:700, color: post.published?'#4cca74':'#555', cursor:'pointer', fontFamily:"'Barlow Condensed',sans-serif", letterSpacing:'.06em', textTransform:'uppercase', flexShrink:0 }}>
              {post.published ? 'Live' : 'Draft'}
            </button>
            <button onClick={() => navigate(`/admin/blog/${post.id}`)} style={{ background:'rgba(255,255,255,.05)', border:'none', borderRadius:20, padding:'5px 14px', fontSize:'.75rem', color:'#888', cursor:'pointer', flexShrink:0 }}>
              Edit
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
